import React from 'react';
import { Hero } from './components/Hero';
import { SystemSection } from './components/SystemSection';
import { VolumesSection } from './components/VolumesSection';
import { BonusSection } from './components/BonusSection';
import { OfferSection } from './components/OfferSection';
import { FaqSection } from './components/FaqSection';
import { SiteFooter } from './components/SiteFooter';
import { PurchaseNotifications } from './components/PurchaseNotifications';
export function App() {
  return <div className="w-full bg-ivory font-sans text-navy" data-id="element-0" data-mp="2mmcde6sej8b8">
      <Hero data-id="element-1" data-mp="2mjpvpebsrcfa" />
      <main data-id="element-2" data-mp="2mjzmv58kvpmk">
        <SystemSection data-id="element-3" data-mp="31agnimde2bie" />
        <VolumesSection data-id="element-4" data-mp="31ayv2f5i4c5m" />
        <BonusSection data-id="element-5" data-mp="31c9tdzg6grpc" />
        <OfferSection data-id="element-6" data-mp="31cjmvx0flgzs" />
        <FaqSection data-id="element-7" data-mp="2wk9zanmsgt0o" />
      </main>
      <SiteFooter data-id="element-8" data-mp="2wj8cxn0bok3n" />
      <PurchaseNotifications data-id="element-9" data-mp="2wip5x1c7ng4e" />
    </div>;
}